// extracted by css-extract-rspack-plugin
export default {"emphasis":"content-editor-plugin-emphasis-Emphasis-emphasis-3c277318"};